import type { JobType } from '@lib/enums/job-type.enum'
import crownCleaning from '@/proposal-document/jobs/crown-cleaning.svg?raw'
import crownRaise from '@/proposal-document/jobs/crown-raise.svg?raw'
import crownRestoration from '@/proposal-document/jobs/crown-restoration.svg?raw'
import crownThin from '@/proposal-document/jobs/crown-thin.svg?raw'
import structuralClearance from '@/proposal-document/jobs/structural-clearance.svg?raw'

/**
 * Each kind of pruning, drawn as it is done: what comes off is rimmed in
 * gold, cut, and taken down, and the tree is then shown doing what the work
 * was for.
 *
 * The markup is inlined rather than loaded as an `<img>`. An image is a
 * separate document that the page's media never reaches, so printed, or for
 * a reader who has turned motion off, it would keep playing, and the PDF
 * would catch a limb in mid-air. Inline, each file's own rules stop it on its
 * still frame, which is drawn to explain the job without moving. The files
 * are ours and bundled, never anything a user wrote.
 *
 * OTHER is access and clean-up, the same on every proposal, so it has no
 * drawing. Keyed by every job type, so a new one has to decide.
 */
export const JOB_ANIMATIONS: Record<JobType, string | null> = {
  CROWN_CLEANING: crownCleaning,
  CROWN_RAISE: crownRaise,
  CROWN_RESTORATION: crownRestoration,
  CROWN_THIN: crownThin,
  STRUCTURAL_CLEARANCE: structuralClearance,
  OTHER: null,
}
